<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - Auftragsdaten</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--confirmation">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <div class="container">
                    <div class="row">
                        <div class="col col-6">
                            <client-information :ask-for-quote="askForQuote" :client-countries="clientCountries"/>
                        </div>
                        <div class="col col-6">
                            <card class="card--grid">
                                <div class="row">
                                    <div class="col-6">
                                        <card-header>
                                            <card-overline>Produzent</card-overline>
                                        </card-header>
                                        <card-content>
                                            <p class="body-2">
                                                <strong>Kontakt</strong><br>
                                                {{ askForQuote?.producer_order?.producer_user.company }}<br>
                                                {{ askForQuote?.producer_order?.producer_user.name }}<br>
                                                {{ askForQuote?.producer_order?.producer_user.street }}
                                                {{ askForQuote?.producer_order?.producer_user.street_no }}<br>
                                                {{ askForQuote?.producer_order?.producer_user.zip }}
                                                {{ askForQuote?.producer_order?.producer_user.city }}<br>
                                                {{
                                                    askForQuote?.producer_order?.producer_user.producer_country.country_name
                                                }}
                                            </p>
                                            <p class="body-2">
                                                Tel.: {{ askForQuote?.producer_order?.producer_user.phone }} <br>
                                                Email: {{ askForQuote?.producer_order?.producer_user.email }}
                                            </p>
                                        </card-content>
                                    </div>
                                    <div class="col-6">
                                        <card-header>
                                            <card-overline>Dokumente</card-overline>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--card table--stripped">
                                                <thead>
                                                <tr>
                                                    <th>Dokumentenname</th>
                                                    <th>Datum</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="producerBillFile">
                                                    <td>P-Rechnung</td>
                                                    <td>{{$dateTime(this.askForQuote.producer_order?.producer_bill.created_at)}}</td>
                                                    <td>
                                                        <a :href="producerBillFile"
                                                           class="btn btn--dense btn--icon-inline">
                                                            <svg-vue icon="documents-file-search" class="icon"/>
                                                        </a>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </card-content>
                                    </div>
                                </div>
                            </card>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <content-toggle toggle="Lieferung">
                                <div class="row">
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>
                                                    Informationen
                                                </card-overline>
                                            </card-header>
                                            <card-content>
                                                <description-group grid="true">
                                                    <description-element title="errechneter K-Liefertermin"
                                                                         :caption="askForQuote?.client_order?.delivery_at"
                                                                         is-date="true"/>
                                                    <description-element title="korrigierter K-Liefertermin"
                                                                         :caption="this.askForQuote?.client_late_delivery?.new_delivery_date"
                                                                         is-date="true"/>
                                                </description-group>
                                            </card-content>
                                        </card>

                                    </div>
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>
                                                    Informationen
                                                </card-overline>
                                            </card-header>
                                            <card-content>
                                                <description-group grid="true">
                                                    <description-element title="P-Liefertermin lt Bestellung"
                                                                         :caption="askForQuote?.producer_order?.delivery_date"
                                                                         is-date="true"/>
                                                    <description-element title="aktueller P-Liefertermin"
                                                                         :caption="askForQuote?.producer_order?.delivery_date_corrected ? askForQuote?.producer_order?.delivery_date_corrected : askForQuote?.producer_order?.delivery_date"
                                                                         is-date="true"/>
                                                </description-group>
                                            </card-content>
                                        </card>
                                        <producer-late-deliveries :ask-for-quote="askForQuote"/>
                                        <producer-order-delivery-reminder :ask-for-quote="askForQuote"
                                                                          :info-only="true"/>
                                    </div>
                                </div>
                            </content-toggle>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <complaint :ask-for-quote="askForQuote" :admin-users="adminUsers"/>
                        </div>
                    </div>

                    <div class="row row--sticky" v-sticky>
                        <div class="col">
                            <form-actions>
                                <form-button type="button" color="error"
                                             icon="document-cross-delete-left"
                                             class="btn--block" @click="clientOrderCancelModal = true;" :disabled="clientOrderCanceled || askForQuote.status === 12">Kundenauftrag
                                    stornieren
                                </form-button>

                                <client-order-cancel-modal :ask-for-quote="askForQuote" v-if="clientOrderCancelModal"
                                                           @closeDialog="clientOrderCancelModal = false;"/>

                                <form-button type="button" color="secondary"
                                             icon="lock-3" class="btn--block" @click="closeAskForQuoteModal = true;"
                                             v-if="askForQuote.status !== 12">
                                    Kundenauftrag schließen
                                </form-button>
                                <modal-dialog title="Kundenauftrag schließen"
                                              text="Wollen Sie den Kundenauftrag wirklich abschließen?" confirm="Ja"
                                              color="secondary" v-if="closeAskForQuoteModal"
                                              @confirmDialog="closeAskForQuote"
                                              @closeDialog="closeAskForQuoteModal = false; closeAskForQuoteError = null;"
                                              :error="closeAskForQuoteError"/>

                                <form-button type="button" color="secondary"
                                             icon="lock-3" class="btn--block" @click="openAskForQuoteModal = true;"
                                             v-if="askForQuote.status === 12">
                                    Kundenauftrag öffnen
                                </form-button>
                                <modal-dialog title="Kundenauftrag öffnen"
                                              text="Wollen Sie den Kundenauftrag wirklich öffnen?" confirm="Ja"
                                              color="secondary" v-if="openAskForQuoteModal"
                                              @confirmDialog="openAskForQuote"
                                              @closeDialog="openAskForQuoteModal = false; openAskForQuoteError = null;"
                                              :error="openAskForQuoteError"/>

                                <form-button type="button" color="error"
                                             icon="document-cross-delete-left" :disabled="producerOrderCanceled || askForQuote.status === 12"
                                             class="btn--block" @click="producerOrderCancelModal = true;">Produzentenauftrag stornieren
                                </form-button>
                                <producer-order-cancel-modal :ask-for-quote="askForQuote" v-if="producerOrderCancelModal" @closeDialog="producerOrderCancelModal = false;" />

                                <form-button type="submit" color="secondary"
                                             icon="lock-3" disabled="disabled"
                                             class="btn--block">Produzentenauftrag schließen
                                </form-button>
                            </form-actions>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ContentToggle from '@partfactory/Shared/Elements/ContentToggle';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import Complaint from '@partfactory/Pages/Admin/AskForQuote/OrderInformations/Complaint';
import ClientInformation from '@partfactory/Pages/Admin/AskForQuote/OrderInformations/ClientInformation';
import ProducerLateDeliveries from '@partfactory/Pages/Admin/AskForQuote/Delivery/ProducerLateDeliveries';
import ProducerOrderDeliveryReminder from '@partfactory/Pages/Admin/AskForQuote/Delivery/ProducerOrderDeliveryReminder';
import FormActions from '@partfactory/Shared/Form/FormActions';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
import ClientOrderCancelModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ClientOrderCancelModal';
import ProducerOrderCancelModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerOrderCancelModal';

export default {
    name: 'OrderInformation',
    components: {
        ProducerOrderCancelModal,
        ClientOrderCancelModal,
        ModalDialog,
        FormActions,
        ProducerOrderDeliveryReminder,
        ProducerLateDeliveries,
        ClientInformation,
        Complaint,
        DescriptionElement,
        DescriptionGroup,
        ContentToggle,
        FormButton, CardContent, CardOverline, CardHeader, Card, AskForQuoteHeader, AppAdminLayout
    },
    props: {
        askForQuote: Object,
        clientCountries: Object,
        adminUsers: Object,
    },
    data() {
        return {
            closeAskForQuoteModal: false,
            closeAskForQuoteError: null,
            openAskForQuoteModal: false,
            openAskForQuoteError: null,
            clientOrderCancelModal: false,
            producerOrderCancelModal: false,
        };
    },
    methods: {
        closeAskForQuote() {
            this.$inertia.post(this.$$route('ask-for-quote.order-information.ask-for-quote-close', {'askForQuote': this.askForQuote.id}), {}, {
                onSuccess: () => {
                    this.closeAskForQuoteModal = false;
                },
                onError: errors => {
                    this.closeAskForQuoteError = errors.closeAskForQuote;
                }
            });
        },
        openAskForQuote() {
            this.$inertia.post(this.$$route('ask-for-quote.order-information.ask-for-quote-open', {'askForQuote': this.askForQuote.id}), {}, {
                onSuccess: () => {
                    this.openAskForQuoteModal = false;
                },
                onError: errors => {
                    this.openAskForQuoteError = errors.openAskForQuote;
                }
            });
        }
    },
    computed: {
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 9);
        },
        clientOrderCanceled() {
            return !! this.askForQuote?.client_order?.canceled_at || ! this.askForQuote?.client_order;
        },
        producerOrderCanceled() {
            return !! this.askForQuote?.producer_order?.canceled_at || ! this.askForQuote?.producer_order;
        },
        producerBillFile() {
            return this.askForQuote.producer_order?.producer_bill ? this.$$route('ask-for-quote-documents.download', {'askForQuoteDocuments': this.askForQuote.producer_order?.producer_bill.id}) : null;
        },
    }
};
</script>
